/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
    FETCH_SUBSCRIPTIONS_REQUEST, FETCH_SUBSCRIPTIONS_SUCCESS, FETCH_SUBSCRIPTIONS_FAILURE,
    UPDATE_SUBSCRIPTION_REQUEST, UPDATE_SUBSCRIPTION_SUCCESS, UPDATE_SUBSCRIPTION_FAILURE,
    CREATE_SUBSCRIPTIONS_REQUEST, CREATE_SUBSCRIPTIONS_SUCCESS, CREATE_SUBSCRIPTIONS_FAILURE,
    DELETE_SUBSCRIPTIONS_REQUEST, DELETE_SUBSCRIPTIONS_SUCCESS, DELETE_SUBSCRIPTIONS_FAILURE
} from '../types/subscriptions';
import { Subscription, SubscriptionList } from '../../data/interfaces';

export const fetchSubscriptionRequest = () => {
    return {
        type: FETCH_SUBSCRIPTIONS_REQUEST
    }
}

export const fetchSubscriptionsSuccess = (subscriptions: SubscriptionList) => {
    return {
        type: FETCH_SUBSCRIPTIONS_SUCCESS,
        payload: subscriptions
    }
}

export const fetchSubscriptionsFailure = (error: string) => {
    return {
        type: FETCH_SUBSCRIPTIONS_FAILURE,
        payload: error
    }
}

export const updateSubscriptionRequest = () => {
    return {
        type: UPDATE_SUBSCRIPTION_REQUEST
    }
}

export const updateSubscriptionSuccess = (subscription: Subscription) => {
    return {
        type: UPDATE_SUBSCRIPTION_SUCCESS,
        payload: subscription
    }
}

export const updateSubscriptionFailure = (error: string) => {
    return {
        type: UPDATE_SUBSCRIPTION_FAILURE,
        payload: error
    }
}

export const createSubscriptionsRequest = () => {
    return {
        type: CREATE_SUBSCRIPTIONS_REQUEST
    }
}

export const createSubscriptionsSuccess = (subscriptions: Subscription) => {
    return {
        type: CREATE_SUBSCRIPTIONS_SUCCESS,
        payload: subscriptions
    }
}

export const createSubscriptionsFailure = (error: string) => {
    return {
        type: CREATE_SUBSCRIPTIONS_FAILURE,
        payload: error
    }
}

export const deleteSubscriptionsRequest = () => {
    return {
        type: DELETE_SUBSCRIPTIONS_REQUEST
    }
}

export const deleteSubscriptionsSuccess = (subscriptionId: string) => {
    return {
        type: DELETE_SUBSCRIPTIONS_SUCCESS,
        payload: subscriptionId
    }
}

export const deleteSubscriptionsFailure = (error: string) => {
    return {
        type: DELETE_SUBSCRIPTIONS_FAILURE,
        payload: error
    }
}
